<template>
  <a-modal title="编号卡"
           :open="modal"
           :width="1200"
           @cancel="cancelCk">
    <a-space class="nav-no-title">
      <a-input-search v-model:value="pagination.search" size="small"
                      class="nav-search"
                      placeholder="搜索"
                      enter-button
                      allow-clear
                      @search="search"/>
    </a-space>

    <a-table size="small"
             :columns="columns"
             :data-source="source"
             :loading="loading"
             :pagination="pagination"
             :onChange="handlePage">
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'material'">
          <a-popover>
            <template #content>
              <div v-for="(v, i) in record.material" :key="`m-${i}`">
                <a-space>
                  <div>ID {{ v.id }}</div>
                  <div>卡ID {{ v.cardId }}</div>
                  <div>编号 {{ v.serial }}</div>
                </a-space>
              </div>
            </template>
            <a-button size="small" type="link">查看</a-button>
          </a-popover>
        </template>

        <template v-else>
          {{ record[column.dataIndex] }}
        </template>
      </template>
    </a-table>
    <template #footer></template>
  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

const source = ref([])
const modal = ref(false)
const loading = ref(false)
const pagination = ref({
  showSizeChanger: true,
  showQuickJumper: true,
  defaultCurrent: 1,
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  total: 0,
  search: '',
  onShowSizeChange: (current, size) => {
    pagination.value.current = 1
    pagination.value.pageSize = size
    query()
  }
})

let id

const columns = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
  }, {
    key: 'userId',
    title: '用户ID',
    dataIndex: 'userId',
  }, {
    key: 'serial',
    title: '编号',
    dataIndex: 'serial',
  }, {
    key: 'material',
    title: '素材',
    dataIndex: 'material',
  }, {
    key: 'createTime',
    title: '下发时间',
    dataIndex: 'createTime',
  },
]

function query() {
  loading.value = true

  axios.get(`/card/${id}/serial`, {
    params: {
      page: pagination.value.current,
      size: pagination.value.pageSize,
      search: pagination.value.search,
    }
  }).then((res) => {
    loading.value = false

    if (res.code === 1) {
      pagination.value.current = res.data.page
      pagination.value.total = res.data.total
      source.value = res.data.data
    }
  })
}

function search() {
  pagination.value.current = 1
  query()
}

function handlePage(param) {
  pagination.value.current = param.current
  pagination.value.pageSize = param.pageSize
  query()
}

function openCk(record) {
  id = record
  pagination.value.current = 1
  pagination.value.search = ''
  query()
  modal.value = true
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>
